<template>
  <div class='inner'>
    <div v-for='item in collections' :key='item.id' class='item'>
      <span @click='toggle(item.id)' v-bind:class='{ changed: item.modified }'>
        <b-icon v-bind:icon="'clipboard-list'" v-bind:class="'clipboard-list'" pack='fas' size='is-small' />
        {{ item.name }}
        <span v-if="!isCollectionMembersRead(item)" class="unread">
          *
        </span>
      </span>
      <template v-if='item.documentsTotal > 0'>
        <span v-text='item.documentsTotal' class='tag is-rounded is-small' />
        <span v-if='item.documentsTotal - item.documentsReadCount > 0'
          v-text='item.documentsTotal - item.documentsReadCount' class='tag is-rounded is-primary' />
      </template>
      <PortefeuilleArboDocs v-if='item.documents.length > 0 && expanded.indexOf(item.id) !== -1' :id='id' :level='level'
        :documents='item.documents' />
    </div>
  </div>
</template>

<script>
import PortefeuilleArboDocs from '@/components/Portefeuille/ArboDocs'

import MixinDocumentHelper from '@/mixins/DocumentHelper'

export default {
  mixins: [MixinDocumentHelper],
  components: {
    PortefeuilleArboDocs,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    level: {
      type: Number,
      required: true,
    },
    collections: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      expanded: [],
    }
  },
  methods: {
    toggle (id) {
      const index = this.expanded.indexOf(id)
      if (index === -1) {
        this.expanded.push(id)
        const item = this.collections.find((i) => i.id === id)
        if (item && !item.details && item.documents.length > 0) {
          try {
            this.$store.dispatch('inv/getCollectionDetails', {
              arboLevel: this.level,
              arboID: this.id,
              collectionID: item.id,
            })
          } catch (e) {
            console.log(e)
            this.apiError(e)
          }
        }
      } else {
        this.expanded.splice(index, 1)
      }
    },
    isCollectionMembersRead (col) {
      return col.documents.every(doc => this.isRead(doc.id))
    }
  },
}
</script>

<style lang='scss' scoped>
.inner {
  position: relative;
  min-height: 10px;
}

.item {
  font-size: 0.9em;
  padding: 0.2em 0 0.2em 0.5em;

  span {
    cursor: pointer;
    ;

    &:hover {
      color: #ed9e1a;
    }
  }
}

.changed {
  color: #35a0d0;
}

.files {
  padding-bottom: 1em;

  span {
    display: block;
    padding: 3px 0 3px 26px;
  }
}

.icon {
  margin-right: 0.15em;
}

.menu {
  position: absolute;
  padding: 0.2em 0.5em;
  background: #fff;
  border: 2px solid #ccc;
  z-index: 2;

  a {
    display: block;
    font-size: 0.75em;
    padding: 0.3em 0;
  }
}

span.unread {
  font-weight: bold;
  color: #ed9e1a;
}

.clipboard-list {
  color: #c28655;
}
</style>
